import { BaseRepository } from "@/repositories/base-repository"
import { type IRentalDispense } from "@/interfaces/api/rental-dispense.interface"

export class RentalDispenseRepository extends BaseRepository<IRentalDispense> {
  protected resourcePath = "administration/rental-dispenses"
}
